export default "__VITE_ASSET__29857e5c__"